import React from 'react';
import { Link } from 'gatsby';
// import { Wrapper } from '..';
// import { Pagination, Categories, StoriesListItem } from '.';
import './Categories.scss';

const Categories = (props) => {
  const {
    categories,
    siteMetadata,
    location,
  } = props;
  const {
    storiesSlug,
    categorySlug,
  } = siteMetadata;
  const { pathname: currentPath } = location;
  const isStoriesHome = currentPath.includes(storiesSlug) && !currentPath.includes(categorySlug);
  return (
    <div className="categories">
      <ul className="categories-list">
        <li className="category">
          <Link
            className={`container ${isStoriesHome ? 'active' : ''}`}
            to={`/${storiesSlug}/`}
            aria-label="See all stories"
          >
            {isStoriesHome && (
              <svg className="icon" viewBox="0 0 16 9" xmlns="http://www.w3.org/2000/svg">
                <path d="M0 0v9l16-4.5z" fillRule="evenodd" />
              </svg>
            )}
            <span>See all</span>
          </Link>
        </li>
        {(categories && categories.length > 0) && (
          categories.map((category) => {
            const { uid, data } = category;
            const { categoryName } = data;
            const categoryPath = `/${storiesSlug}/${categorySlug}/${uid}/`;
            const isActive = currentPath.includes(categoryPath);
            return (
              <li className="category" key={uid}>
                <Link
                  className={`container ${isActive ? 'active' : ''}`}
                  to={categoryPath}
                  aria-label={`Read more about ${categoryName.text}`}
                >
                  {isActive && (
                    <svg className="icon" viewBox="0 0 16 9" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0 0v9l16-4.5z" fillRule="evenodd" />
                    </svg>
                  )}
                  <span>{categoryName.text}</span>
                </Link>
              </li>
            );
          })
        )}
      </ul>
    </div>
  );
};

export default Categories;
